import axios from "axios";
import { BACKEND_API_URL, FRONTEND_APP_URL } from "../environment";
import { authInfoSeter } from "../lib/functions";

// const BACKEND_API_URL = `${process.env.REACT_APP_API_HOSTNAME}:${process.env.REACT_APP_API_BACKEND_PORT}`;
// const FRONTEND_APP_URL = `${process.env.REACT_APP_API_HOSTNAME}:${process.env.REACT_APP_API_FRONTEND_PORT}`;

export { BACKEND_API_URL, FRONTEND_APP_URL };

const axiosInstance = axios.create({
  baseURL: `${BACKEND_API_URL}`,
  timeout: 10000, // Optional: Timeout for requests
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

// Add a request interceptor to inject tokens or modify requests
axiosInstance.interceptors.request.use(
  (config) => {
    config.url = `${config.url}`;
    // const authInfo = JSON.parse(sessionStorage.getItem("auth_info") || "{}");
    const token = localStorage.getItem('token');
    // const token = authInfo?.token;
    if (token) {
      config.headers["auth-token"] = ` ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for global error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally
    if (error.response?.status === 401) {
      // localStorage.clear()
        localStorage.removeItem("token");
  localStorage.removeItem("auth_info");
      // Handle session expiration
      sessionStorage.clear();
      // Unauthorized - Maybe redirect to login
      console.error("Unauthorized. Redirecting to login...");
      window.location.href = "/login"

      // Stop further processing (prevents showing "Internal Error")
      return new Promise(() => { }); // Creates a never-resolving promise
    }
    return Promise.reject(error);
  }
);

//old method
export const requestData = async (method, endPoint, data = {}) => {
  try {
    let response;
    if (method === "get") {
      response = await axiosInstance.get(endPoint);
    } else if (method === "post") {
      response = await axiosInstance.post(endPoint, data);
    } else if (method === "put") {
      response = await axiosInstance.put(endPoint, data);
    } else {
      throw new Error("Invalid method");
    }
    return response;
  } catch (err) {
    console.log(err);
    // Extract backend error if available
    let message = "Request failed";

    if (err.response) {
      // Axios response available
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `HTTP ${err.response.status}: Request failed`;
    } else if (err.message) {
      // Network or other error
      message = err.message;
    }

    console.error("API Error:", err.response || err);
    const error = new Error(message);
    error.response = err.response?.data;
    throw error;
  }
};

export const fetchData = (endPoint) => requestData("get", endPoint);
export const postData = (endPoint, data) => requestData("post", endPoint, data);
export const putData = (endPoint, data) => requestData("put", endPoint, data);

export default axiosInstance;
